import React, { useState, useEffect, useRef } from "react";

import PropTypes from "prop-types";
import { Tabs, Tab, Typography, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";

import Sidebar from "../../elements/Sidebar";
import workSpaceCss from "../../css/workSpaceOverView.module.css";
import FSSideMenu from "../../components/standalonefs/FSSideMenu";
import FSTopBar from "../../components/standalonefs/FSTopBar";

import Modal from "../../elements/Modal";
import modalcss from "../../css/modal.module.css";
import { ReactComponent as DeleteIconWhite } from "../../assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";
import buttoncss from "../../css/button.module.css";
import { Button } from "../../elements/Button";
import { set } from "react-hook-form";
import swal from "sweetalert";
import {
  deletePopulateFSApiHandler,
  getPopulateFSDetailsApiHandler,
  updatePopulateFSApiHandler,
} from "../../../WorkSpace/Components/ApiServices/apiHandler";
import { motion } from "framer-motion";
import commoncss from "../../css/common.module.css";
import bookclosurecss from "../../css/bookclosure.module.css";
import QuillReactEditor from "../../components/QuillReactEditor";
import FSTable from "./FSTable";

import sampleData from "./sample_fs.json";
import bsNotesData from "./bsnotes_fs.json";

const StandaloneFinancialStatement = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const categories = sampleData.map((s) => s.category);
  const [activeCat, setActiveCat] = useState("BS");
  const [isNotes, setIsNotes] = useState(false);
  const [dataState, setDataState] = useState(bsNotesData);
  const [loadData, setLoadData] = useState([]);
  const [notesId, setNotesId] = useState(null);
  const [redirectNote, setRedirectNote] = useState(null);
  const [subMenuId, setSubMenuId] = useState(null);
  const [subgroupId, setSubGroupId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [subMenu, setSubMenu] = useState(null);
  const [rows, setRows] = useState([]);
  const [notesData, setNotesData] = useState(null);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const project_id = localStorage.getItem("project_id");
  // const project_id = "6926c0af2325c750306470a0";
  // const project_id = "6936ba0b2165b04c88fb0a42";

  // Whenever data is loaded from API, push into rows
  useEffect(() => {
    if ((activeCat === "BS") || (activeCat === "PL")) {
      const result = transformData(loadData ?? []);
      setRows(result ?? []);
    } else {

      setRows(loadData ?? []);
    }
  }, [loadData]);


  // Configure columns + submenu based on activeCat & rows
  useEffect(() => {
    setColumns([]);

    // BS / PL
    if (activeCat === "BS" || activeCat === "PL") {
      setIsNotes(false);
      setSubMenu(null);
      setColumns([
        {
          label: "Particular",
          field: "particular",
          align: "left",
          editable: false,
        },
        {
          label: "Notes",
          field: "notes",
          align: "left",
          editable: false,
          type: "redirect",
        },
        {
          label: "Current Year",
          field: "currentYear",
          align: "right",
          editable: false,
          type: "number",
        },
        {
          label: "Previous Year",
          field: "previousYear",
          align: "right",
          editable: false,
          type: "number",
        },
        {
          label: "References",
          field: "references",
          align: "left",
          editable: false,
          type: "array",
        },
      ]);
      return;
    }

    // SOCIE / Cashflow / Disclosure
    if (["socie", "cashflow", "disclosure"].includes(activeCat)) {
      setIsNotes(false);
      setSubMenu(null);

      if (rows.length > 0) {
        const catRows = Object.keys(rows[0] || {});
        const tableCols = catRows
          .filter(
            (item) =>
              item !== "_id" && item !== "lineType" && item !== "references"
          )
          .map((item) => ({
            label: item,
            field: item,
            align: "left",
            editable: true,
            type: "text",
          }));

        setColumns(tableCols);
      }
      return;
    }

    // Notes categories
    if (
      ["general notes", "BS notes", "PL notes", "checklist"].includes(activeCat)
    ) {
      setIsNotes(true);
      const submenuArray = rows.map((item) => ({
        label: item.particular,
        value: item._id,
        subGroup: item.subgroup, // assuming backend uses `subgroup`
      }));
      setSubMenu({
        category: activeCat,
        submenu: submenuArray,
      });
      setColumns([]);
      return;
    }

    // Default
    setIsNotes(false);
    setSubMenu(null);
    setColumns([]);
  }, [activeCat, rows]);

  // 🔹 Auto-select first submenu item (for notes + checklist)
  useEffect(() => {
    if (!isNotes) return;
    if (!subMenu?.submenu?.length) return;

    // Don't override if something is already selected (manual click / redirect)
    if (subMenuId) return;

    const first = subMenu.submenu[0];
    setSubMenuId(first.value);
  }, [isNotes, activeCat, subMenu, subMenuId]);

  const handleRowsChange = (updatedRows) => {
    console.log("updatedRows", updatedRows);
    // If you want local update from FSTable:
    // setRows(updatedRows);
  };

  const menuItems = [
    { label: "Balance Sheet", value: "BS" },
    { label: "P&L Statement", value: "PL" },
    { label: "General Notes", value: "general notes" },
    { label: "CashFlow", value: "cashflow" },
    { label: "SOCIE", value: "socie" },
    { label: "Balance Sheet Notes", value: "BS notes" },
    { label: "PNL Statement Notes", value: "PL notes" },
    { label: "Disclosures", value: "disclosure" },
    { label: "Disclosures Checklist", value: "checklist" },
  ];

  const getPopulateFS = (cat) => {
    const getParams = {
      category: cat,
      projectID: project_id,
    };
    getPopulateFSDetailsApiHandler(getParams)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.success === true) {
          const catData = response?.data?.data;
          setLoadData(catData);
        }
      })
      .catch((error) => {
        setLoadData([]);
      });
  };

  // When category changes, reset and fetch
  useEffect(() => {
    setColumns([]);
    setSubMenu(null);
    setIsNotes(false);
    setNotesData(null);
    setSubGroupId(null);
    setSubMenuId(null);
    getPopulateFS(activeCat);
  }, [activeCat]);

  const debounceTimer = useRef(null);

  const handleTableEdit = ({ _id, key, value, type = "table", tableId }) => {
    const params = {
      category: activeCat,
      projectID: project_id,
    };
    console.log("_id, key, value, type", _id, key, value, type);

    if (isNotes && type !== "text") {
      params["groupID"] = subMenuId;
      if (activeCat === "checklist") {
        params["subgroupID"] = _id;
      } else {
        params["subgroupID"] = tableId;
        params["rowID"] = _id;
      }
    } else {
      if (
        activeCat === "BS" ||
        activeCat === "PL" ||
        activeCat === "socie" ||
        activeCat === "cashflow" ||
        activeCat === "disclosure"
      ) {
        params["groupID"] = _id;
      }
    }

    const payload = {};

    if (isNotes && type === "text") {
      params["groupID"] = subMenuId;
      params["subgroupID"] = _id;

      payload["textRaw"] = key; // html
      payload["textPlain"] = value; // plaintext
    } else {
      payload[key] = value;
    }

    console.log("update params,payload", params, payload);

    updatePopulateFSApiHandler(params, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          // ✅ UPDATE LOCAL STATE SO UI PERSISTS THE CHANGE

          if (isNotes) {
            if (type === "text") {
              // Update text subgroup in rows
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== _id) return sg;
                        return {
                          ...sg,
                          textRaw: payload.textRaw,
                          textPlain: payload.textPlain,
                        };
                      }
                    ),
                  };
                })
              );
            } else {
              // Update table row inside subgroup
              setRows((prev) =>
                prev.map((group) => {
                  if (group._id !== subMenuId) return group;
                  return {
                    ...group,
                    subgroup: (group.subgroup || group.subGroup || []).map(
                      (sg) => {
                        if (sg._id !== subgroupId) return sg;
                        return {
                          ...sg,
                          table: (sg.table || []).map((row) =>
                            row._id === _id ? { ...row, [key]: value } : row
                          ),
                        };
                      }
                    ),
                  };
                })
              );
            }
          } else {
            // Non-notes tables (BS, PL, etc.)
            setRows((prev) =>
              prev.map((row) =>
                row._id === _id ? { ...row, [key]: value } : row
              )
            );
          }
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update the data",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to save the data",
          "error"
        );
      });
  };

  const handleTableEditDebounced = (args) => {
    clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      console.log("args", args);

      handleTableEdit(args);
    }, 2000); // 2 seconds
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimer.current); // cleanup on unmount
  }, []);

  const ShowDetails = () => {
    return (
      <>
        <FSTable
          columns={columns}
          rows={rows}
          onRowsChange={handleRowsChange}
          onCellChangeImmediate={handleTableEditDebounced}
          redirectTo={redirectTo}
        />
      </>
    );
  };

  const ShowChecklist = ({ subMenuId }) => {
    if (!subMenu) return null;

    const selNote = subMenu.submenu.find((item) => item.value === subMenuId);
    const rows = selNote?.subGroup || [];

    const checklistColumns = [
      {
        label: "Paragraph reference",
        field: "reference",
        align: "left",
        editable: false,
        type: "popup",
      },
      {
        label: "Disclosure",
        field: "notes",
        align: "left",
        maxWidth: 200,
        editable: false,
        type: "text",
      },
      {
        label: "Yes",
        field: "value",
        optionValue: "Y",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "No",
        field: "value",
        optionValue: "N",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "NA",
        field: "value",
        optionValue: "NA",
        align: "center",
        editable: true,
        type: "checkbox",
      },
      {
        label: "Remarks",
        field: "remark",
        align: "left",
        editable: true,
        type: "text",
      },
    ];

    return (
      <>
        <FSTable
          columns={checklistColumns}
          rows={rows}
          onRowsChange={handleRowsChange}
          onCellChangeImmediate={handleTableEditDebounced}
          redirectTo={redirectTo}
        />
      </>
    );
  };

  const getPopulateFSNotes = async (cat) => {
    try {
      const getParams = {
        category: cat,
        projectID: project_id,
      };

      const response = await getPopulateFSDetailsApiHandler(getParams);

      console.log("response", response);

      if (response?.data?.success === true) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const redirectTo = async (arg) => {
    let subNotesCat = null;

    if (activeCat === "BS") {
      setActiveCat("BS notes");
      subNotesCat = "BS notes";
    }
    if (activeCat === "PL") {
      setActiveCat("PL notes");
      subNotesCat = "PL notes";
    }

    if (subNotesCat) {
      const data = await getPopulateFSNotes(subNotesCat);
      const resultId = data.find((item) => item.notes === arg)?._id;
      console.log("resultId", resultId);
      setRedirectNote(resultId || null);
    }
  };

  // Drive notesData from rows + subMenuId (for notes views, not checklist)
  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = rows.find((item) => item._id === subMenuId) || null;
    setNotesData(selNote);
  }, [isNotes, activeCat, subMenuId, rows]);

  // When notesData changes, pick first table-type subgroupId
  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !notesData) return;

    const subGroups = notesData.subgroup || notesData.subGroup || [];
    const firstTableSg = subGroups.find(
      (sg) => (sg?.dataType ?? sg?.datatype) === "table"
    );

    setSubGroupId(firstTableSg?._id ?? null);
  }, [isNotes, activeCat, notesData]);

  const showNotesDetails = (noteId) => {
    setSubMenuId(noteId);
  };

  const deletePopulateFS = async (subgroupID) => {
    try {
      const getParams = {
        category: activeCat,
        projectID: project_id,
        groupID: subMenuId,
        subgroupID: subgroupID
      };

      const response = await deletePopulateFSApiHandler(getParams);

      console.log("response", response);
      setUpdateTrigger((prev) => prev + 1);
      const delEl = document.getElementById(subgroupID)
      if(delEl) delEl.style.display ="none"
      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    if (!isNotes || activeCat === "checklist" || !subMenuId) {
      setNotesData(null);
      return;
    }

    const selNote = rows.find((item) => item._id === subMenuId) || null;
    setNotesData(selNote);
    console.log("updated");
    
  }, [updateTrigger]);

  const renderSubGroups = (notesData) => {
    const subGroups = notesData?.subgroup || notesData?.subGroup || [];

    return subGroups.map((sg, idx) => {
      const type = sg?.dataType ?? sg?.datatype ?? "";

      // ---------- TABLE ----------
      if (type === "table") {
        const tableItems = Array.isArray(sg.table) ? sg.table : [];

        if (tableItems.length === 0) {
          return (
            <div key={`table-empty-${idx}`} className="mb-4">
              <small>No table data available</small>
            </div>
          );
        }
        // console.log("sg",sg);

        const catRows = Object.keys(tableItems[0] || {});
        const tableCols = catRows
          .filter((col) => col !== "_id")
          .map((col) => {
            if (col === "references") {
              return {
                label: col,
                field: col,
                align: "left",
                editable: false,
                type: "checklistref",
              };
            }
            return {
              label: col,
              field: col,
              align: "left",
              editable: true,
              type: "text",
            };
          });

        return (
          <React.Fragment key={`table-${idx}`}>
            <FSTable
              columns={tableCols}
              rows={tableItems}
              onRowsChange={handleRowsChange}
              onCellChangeImmediate={handleTableEditDebounced}
              redirectTo={redirectTo}
              tableTitle={sg?.tableTitle}
              tableId={sg?._id}
              tableType={sg?.tableType}
              deletePopulateFS={deletePopulateFS}
            />
          </React.Fragment>
        );
      }

      // ---------- TEXT ----------
      if (type === "text") {
        return (
          <div className="mt-5" key={`text-${idx}`}>
            <QuillReactEditor
              value={sg?.textRaw ?? ""}
              onChange={(content) => {
                handleTableEdit({
                  _id: sg?._id,
                  key: content.html,
                  value: content.text,
                  type: "text",
                });
              }}
            />
          </div>
        );
      }

      // ---------- FALLBACK ----------
      return <div key={`empty-${idx}`} />;
    });
  };

  const transformData = (data) => {
    const output = [];

    const walk = (node) => {
      if (node.level === 3) return;
      // level 1 => header, others => row
      const type = node.level === 1 ? "header" : "row";

      output.push({
        _id: node._id,
        lineType: type,
        particular: node.name,
        notes: node.notes ?? null,
        currentYear: node.currentYear ?? null,
        previousYear: node.previousYear ?? null,
        references: node.references ?? []
      });

      if (node.subgroup && node.subgroup.length) {
        node.subgroup.forEach(walk);
      }
    };

    data.forEach(walk);
    return output;
  };

  return (
    <>
      <div className={`${workSpaceCss.df}`}>
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >
            <FSSideMenu
              title="Financial Statements"
              menuItems={menuItems}
              subMenu={subMenu}
              activeCat={activeCat}
              setActiveCat={setActiveCat}
              setSubMenuId={setSubMenuId}
              showNotesDetails={showNotesDetails}
              redirectNote={redirectNote}
              setRedirectNote={setRedirectNote}
              subMenuId={subMenuId}
            />
          </motion.div>
          <div
            className={bookclosurecss.bookClosureContent}
            style={{ width: "81vw" }}
          >
            <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
              <FSTopBar history={history} />
            </div>
            <div
              style={{
                height: "88vh",
                overflow: "auto",
                padding: "0px 20px",
              }}
            >
              {!isNotes && activeCat !== "checklist" && <ShowDetails />}

              {isNotes && notesData && activeCat !== "checklist" && (
                <>
                  {renderSubGroups(notesData)}
                </>
              )}

              {isNotes && subMenuId && activeCat === "checklist" && (
                <ShowChecklist subMenuId={subMenuId} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StandaloneFinancialStatement;
